import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchPermissions } from "../permissionsSlice";
import { fetchOperatorSpecificConfigurations } from "../slices/OperatorManagement/GetConfigurationByOperatorId/thunk";
import { openMLAppWindow, setMLAppWindow } from "../Components/Utils/MLUtils";
import { hasPermission } from "../Components/Utils/UtilityFunctions";
import { fetchAllCurrencyCodes } from "../slices/OperatorManagement/GetCurrencyCodes/thunk";

const Navdata = () => {
  const history = useNavigate();
  const [isDashboard, setIsDashboard] = useState(false);
  const [isHome, setIsHome] = useState(false);
  const [isCustomer, setIsCustomer] = useState(false);
  const [isStation, setIsStation] = useState(false);
  const [isReservation, setIsResevation] = useState(false);
  const [isPartner, setIsPartner] = useState(false);
  const [isSubscription, setIsSubscription] = useState(false);
  const [isPricing, setIsPricing] = useState(false);
  const [isDevice, setIsDevice] = useState(false);
  const [isCustomerDashboard, setIsCustomerDashboard] = useState(false);
  const [isOperator, setIsOperator] = useState(false);
  const [isDocument, setIsDocument] = useState(false);
  const [isSetting, setIsSetting] = useState(false);
  const [isProfile, setIsProfile] = useState(false);
  const [isCharging, setIsCharging] = useState(false);
  const [isAnalytics, setIsAnalytics] = useState(false);
  const [isReport, setIsReport] = useState(false);
  const [isEMSReport, setIsEMSReport] = useState(false);
  const [isStepTracking, setIsStepTracking] = useState(false);

  const [isMvnoDashboard, setIsMvnoDashboard] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [isCustomerInvoice, setIsCustomerInvoice] = useState(false);
  const [isCustomerOrder, setIsCustomerOrder] = useState(false);
  const [isCustomerPayment, setIsCustomerPayment] = useState(false);
  const [isCustomerProfile, setIsCustomerProfile] = useState(false);

  const [isMonitoringAndControl, setIsMonitoringAndControl] = useState(false);
  const [isTransactions, setIsTransactions] = useState(false);
  const [isConfigurations, setIsConfigurations] = useState(false);

  const [isAdminPartnerOffer, setIsAdminPartnerOffer] = useState(false);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const operatorId = localStorage.getItem("operatorId");
  const roleName = localStorage.getItem("roleName");
  const [iscurrentState, setIscurrentState] = useState("");
  useEffect(() => {
    dispatch(fetchPermissions());
    if (roleName !== "Customer" && roleName !== "EVPartnerAdmin" && roleName !== 'ISPPartnerAdmin' && roleName !== 'partnerAdmin') {
      dispatch(fetchOperatorSpecificConfigurations(setLoading, operatorId));
    }
  }, [dispatch, roleName]);
  const permissions = useSelector((state) => state.permissions.permissions);
  const rawPermissions = useSelector(
    (state) => state.permissions.permissionsMap,
  );

  const permissionsMap = new Map(
    rawPermissions.map(([key, value]) => [key, new Set(value)]),
  );
  const currencies = useSelector(
    (state) => state.GetAllCurrency.GetAllCurrency,
  );
  const operatorConfiguration = useSelector(
    (state) =>
      state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration,
  );
  useEffect(() => {
    dispatch(fetchPermissions());
    if (roleName !== "Customer" && roleName !== "EVPartnerAdmin" && roleName !== 'ISPPartnerAdmin' && roleName !== 'partnerAdmin') {
      dispatch(fetchOperatorSpecificConfigurations(setLoading, operatorId));
    }
    dispatch(fetchAllCurrencyCodes(setLoading));
  }, [dispatch, roleName, operatorId]);

  const isEIPEnabled =
    operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;

  const currency =
    operatorConfiguration?.configurations?.DefaultCurrency?.value?.CurrencyCode?.value?.toString();
  const selectedCurrency = currencies?.find(
    (item) => item.currencyCode === currency,
  );

  useEffect(() => {
    if (selectedCurrency?.symbol) {
      localStorage.setItem("currencySymbol", selectedCurrency.symbol);
    } else {
      localStorage.setItem("currencySymbol", "$");
    }
  }, [selectedCurrency]);

  const isMLAnalyticsEnabled =
    operatorConfiguration?.configurations?.ML?.value?.MLEnabled?.value === true;
  // operatorConfiguration?.configurations
  //   ?.find((config) => config.name === "ML")
  //   ?.value?.find((item) => item.key === "MLEnabled")?.value?.[0] === "True";

  function redirectToMLDashboard() {
    const accessToken = localStorage.getItem("token");
    const refreshToken = localStorage.getItem("refreshToken");
    const userName = localStorage.getItem("userName");

    if (!accessToken) {
      history(location.pathname, { replace: true });
    }

    // Listen for ML to request the token
    else {
      localStorage.setItem("redirectedToUMP", "true");
      // const otherAppUrl = `${window.env.REACT_APP_ML_REDIRECT_URL}/TemplateList`;
      // const otherWindow = window.open(otherAppUrl);
      const otherWindow = openMLAppWindow();
      setMLAppWindow(otherWindow);
      window.addEventListener("message", (event) => {
        if (
          event.origin === window.env.REACT_APP_ML_REDIRECT_URL &&
          event.data === "requestToken"
        ) {
          otherWindow?.postMessage(
            {
              token: accessToken,
              refreshToken: refreshToken,
              redirectedFromUMP: "true",
              userName: userName,
            },
            `${window.env.REACT_APP_ML_REDIRECT_URL}/TemplateList`,
          );
        }
      });
    }
  }

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }
  const customerPermission = hasPermission(
    permissionsMap,
    "customer",
    "customer",
  );
  const operatorPermission = hasPermission(
    permissionsMap,
    "operators",
    "operator",
  );
  const stationPermission = hasPermission(permissionsMap, "station", "station");
  const offerPermission = hasPermission(permissionsMap, "pricing", "offer");
  const uomPermission = hasPermission(permissionsMap, "pricing", "uom");
  const quotaPermission = hasPermission(permissionsMap, "charging", "quota");
  const attributePermission = hasPermission(
    permissionsMap,
    "pricing",
    "attribute",
  );
  const resourcePermission = hasPermission(
    permissionsMap,
    "pricing",
    "resource",
  );
  const servicePermission = hasPermission(permissionsMap, "pricing", "service");
  const reservationPermission = hasPermission(
    permissionsMap,
    "reservation",
    "reservation",
  );
  const dashboardPermission = hasPermission(
    permissionsMap,
    "dashboard",
    "dashboard",
  );
  const reportPermission = hasPermission(permissionsMap, "reports", "reports");
  const emsReportPermission = hasPermission(
    permissionsMap,
    "EMSReports",
    "emsreports",
  );
  const devicePermission = hasPermission(permissionsMap, "device", "device");
  const PartnerPermission = hasPermission(
    permissionsMap,
    "partners",
    "partner",
  );
  const SubscriptionPermission = hasPermission(
    permissionsMap,
    "customer",
    "subscription",
  );
  const orderPermissionList = hasPermission(
    permissionsMap,
    "customer",
    "order",
  );
  const commissionPolicyPermission = hasPermission(
    permissionsMap,
    "partners",
    "commissionPolicy",
  );
  const invoicePermission =
    operatorConfiguration?.configurations?.BillingManagement?.value
      ?.BillingEnabled?.value === true
      ? true
      : false;
  const orderPermission =
    operatorConfiguration?.configurations?.orderManagement?.value?.OrderEnabled
      ?.value === true
      ? true
      : false;
  const paymentPermission = hasPermission(
    permissionsMap,
    "customer",
    "payment",
  );
  const policyPermission = hasPermission(permissionsMap, "charging", "policy");
  const chargingPermission = hasPermission(permissionsMap, "charging");
  const pricingPermission = hasPermission(permissionsMap, "pricing");
  const taskPermission = hasPermission(permissionsMap, "customer", "task");
  const userPermission = hasPermission(
    permissionsMap,
    "administration",
    "userManagement",
  );
  const profilePermission = hasPermission(
    permissionsMap,
    "administration",
    "profileManagement",
  );
  const configurationPermission = hasPermission(
    permissionsMap,
    "administration",
    "configurations",
  );
  const midsessionPermission = hasPermission(
    permissionsMap,
    "charging",
    "midsessioncdr",
  );
  const ratinggroupPermission = hasPermission(
    permissionsMap,
    "charging",
    "ratinggroup",
  );
  const peerconfigurationPermission = hasPermission(
    permissionsMap,
    "charging",
    "peerConfigurations",
  );
  const rolesPermission = hasPermission(
    permissionsMap,
    "administration",
    "roles",
  );

  const configurationsPermission = hasPermission(
    permissionsMap,
    "configuration",
  );
  const transactionPermission = hasPermission(permissionsMap, "transactions");
  const monitoringAndControlPermission = hasPermission(
    permissionsMap,
    "monitoringAndControl",
  );

  const itemPermission = hasPermission(permissionsMap, "configuration", "item");
  const categoryPermission = hasPermission(
    permissionsMap,
    "configuration",
    "category",
  );
  const subCategoryPermission = hasPermission(
    permissionsMap,
    "configuration",
    "subcategory",
  );
  const pricebookPermission = hasPermission(
    permissionsMap,
    "configuration",
    "pricebook",
  );
  const uomInventoryPermission = hasPermission(
    permissionsMap,
    "configuration",
    "uom",
  );
  const attributeInventoryPermission = hasPermission(
    permissionsMap,
    "configuration",
    "attribute",
  );
  const locationPermission = hasPermission(
    permissionsMap,
    "configuration",
    "location",
  );
  const purchaseorderPermission = hasPermission(
    permissionsMap,
    "transactions",
    "purchaseorder",
  );
  const salesorderPermission = hasPermission(
    permissionsMap,
    "transactions",
    "salesorder",
  );
  const stocktranferPermission = hasPermission(
    permissionsMap,
    "transactions",
    "transfer",
  );
  const adjustmentsPermission = hasPermission(
    permissionsMap,
    "transactions",
    "adjustment",
  );
  const inventoryPermission = hasPermission(
    permissionsMap,
    "transactions",
    "inventory",
  );
  const notificationsPermission = hasPermission(
    permissionsMap,
    "monitoringandcontrol",
    "notifications",
  );

  const adminpartnerofferPermission = hasPermission(
    permissionsMap,
    "cms",
    "offer",
  );

  const labelText = isEIPEnabled
    ? roleName === "telcoAdmin" ||
      roleName === "telcoOperationUser" ||
      roleName === "telcoBusinessUser"
      ? "Device Search"
      : "Device List"
    : roleName === "telcoAdmin" ||
        roleName === "telcoOperationUser" ||
        roleName === "telcoBusinessUser"
      ? "Customer Search"
      : "Customer List";

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Customer") {
      setIsCustomer(false);
    }
    if (iscurrentState !== "Station") {
      setIsStation(false);
    }
    if (iscurrentState !== "Reservation") {
      setIsResevation(false);
    }
    if (iscurrentState !== "Pricing") {
      setIsPricing(false);
    }
    if (iscurrentState !== "Partner") {
      setIsPartner(false);
    }
    if (iscurrentState !== "Device") {
      setIsDevice(false);
    }
    if (iscurrentState !== "CustomerDashboard") {
      setIsCustomerDashboard(false);
    }
    if (iscurrentState !== "MvnoDashboard") {
      setIsMvnoDashboard(false);
    }
    if (iscurrentState !== "CustomerInvoice") {
      setIsCustomerInvoice(false);
    }
    if (iscurrentState !== "CustomerOrder") {
      setIsCustomerOrder(false);
    }
    if (iscurrentState !== "User") {
      setIsUser(false);
    }
    if (iscurrentState !== "Profile") {
      setIsProfile(false);
    }
    if (iscurrentState != "Charging") {
      setIsCharging(false);
    }
    if (iscurrentState != "Analytics") {
      setIsAnalytics(false);
    }
    if (iscurrentState != "Report") {
      setIsReport(false);
    }
    if (iscurrentState != "EMS Report") {
      setIsEMSReport(false);
    }
    if (iscurrentState != "Step Tracker") {
      setIsStepTracking(false);
    }
    if (iscurrentState != "Configuration") {
      setIsConfigurations(false);
    }
    if (iscurrentState != "Transactions") {
      setIsTransactions(false);
    }
    if (iscurrentState != "Monitoring and Control") {
      setIsMonitoringAndControl(false);
    }
  }, [
    history,
    iscurrentState,
    isCustomerDashboard,
    isDashboard,
    isCustomer,
    isStation,
    isReservation,
    isPricing,
    isPartner,
    isDevice,
    isUser,
    isProfile,
    isCharging,
    isAnalytics,
    isReport,
    isEMSReport,
    isStepTracking,
    isConfigurations,
    isTransactions,
    isMonitoringAndControl,
    isAdminPartnerOffer,
  ]);

  useEffect(() => {
    if (location.state?.expandMenu === "monitoringAndControl") {
      setIsMonitoringAndControl(true);
      setIscurrentState("Monitoring and Control");
    }
  }, [location.state, location.pathname]);

  useEffect(() => {
  if (
    location.pathname === "/report" ||
    location.pathname === "/finance-report" ||
    location.pathname === "/operational-report"
  ) {
    setIsDashboard(true);
    setIscurrentState("Dashboard");
  } else if(location.pathname === "/offers"){
    setIsAdminPartnerOffer(true);
    setIscurrentState("Admin Partner Offer");
  }
}, [location.pathname]);

  const menuItems = [
    {
      label: "",
      isHeader: true,
    },
    // dashboardPermission && roleName !== "Customer"
    //   ? {
    //       id: "dashboard",
    //       label: "Dashboard",
    //       icon: "ri-dashboard-line",
    //       link: "/dashboard",
    //       stateVariables: isDashboard,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsDashboard(!isDashboard);
    //         setIscurrentState("Dashboard");
    //         updateIconSidebar(e);
    //       },
    //     }
    //   : null,
dashboardPermission && roleName !== "Customer"
  ? {
      id: "dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-line",
      link:
        roleName === "EVPartnerAdmin"
          ? "/finance-report"
          : "/dashboard",
      stateVariables: isDashboard,
      click: function (e) {
        e.preventDefault();
        if (roleName === "EVPartnerAdmin") {
          setIsDashboard(true);
          setIscurrentState("Dashboard");
          history("/finance-report");
          return;
        }

        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
        history("/report");
      },
      ...(reportPermission
        ? {
            subItems: [
              ...(roleName !== "EVPartnerAdmin"
                ? [
                    {
                      id: "revenue-report",
                      label: "Business Overview",
                      link: "/report",
                      parentId: "dashboard",
                    },
                  ]
                : []),
              {
                id: "finance-report",
                label: "Financial Insights",
                link: "/finance-report",
                parentId: "dashboard",
              },
              {
                id: "operational-report",
                label: "Operations Insights",
                link: "/operational-report",
                parentId: "dashboard",
              },
            ],
          }
        : {}),
    }
  : null,
    roleName === "Customer"
      ? {
          id: "home",
          label: "Home",
          icon: "ri ri-home-2-line",
          link: "/dashboard",
          stateVariables: isHome,
          click: function (e) {
            e.preventDefault();
            setIsHome(!isHome);
            setIscurrentState("Home");
            updateIconSidebar(e);
          },
        }
      : null,
    SubscriptionPermission &&
    SubscriptionPermission?.has("view") &&
    roleName === "Customer"
      ? {
          id: "subscription",
          label: "Subscriptions",
          icon: " ri-shopping-cart-line",
          link: "/subscription",
          stateVariables: isSubscription,
          click: function (e) {
            e.preventDefault();
            setIsSubscription(!isSubscription);
            setIscurrentState("Subscription");
            updateIconSidebar(e);
          },
        }
      : null,
    roleName === "Customer"
      ? {
          id: "documents",
          label: "Documents",
          icon: "ri ri-folders-line",
          link: "/documents",
          stateVariables: isDocument,
          click: function (e) {
            e.preventDefault();
            setIsDocument(!isDocument);
            setIscurrentState("Documents");
            updateIconSidebar(e);
          },
        }
      : null,

    roleName === "Customer" && orderPermissionList
      ? {
          id: "order",
          label: "Orders",
          icon: "ri ri-shopping-cart-line",
          link: "/customer/order",
          stateVariables: isCustomerOrder,
          click: function (e) {
            e.preventDefault();
            setIsCustomerDashboard(!isCustomerOrder);
            setIscurrentState("CustomerOrder");
            updateIconSidebar(e);
          },
        }
      : null,

    // roleName === "Customer" && orderPermission ? {
    //   id: "customerOrder",
    //   label: "Orders",
    //   icon: "ri ri-shopping-cart-line",
    //   link: "/customer/order",
    //   stateVariables: isCustomerOrder,
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsCustomerDashboard(!isCustomerOrder)
    //     setIscurrentState("CustomerOrder")
    //     updateIconSidebar(e)
    //   }
    // } : null,
    // roleName === "Customer" && invoicePermission ? {
    //   id: "customerInvoice",
    //   label: "Invoice",
    //   icon: "ri ri-bill-line",
    //   link: "/customer/invoice",
    //   stateVariables: isCustomerInvoice,
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsCustomerDashboard(!isCustomerInvoice)
    //     setIscurrentState("CustomerInvoice")
    //     updateIconSidebar(e)
    //   }
    // } : null,
    // roleName === "Customer" && paymentPermission ? {
    //   id: "customerPayment",
    //   label: "Payments",
    //   icon: "ri ri-bank-card-line",
    //   link: "/customer/payment",
    //   stateVariables: isCustomerPayment,
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsCustomerDashboard(!isCustomerPayment)
    //     setIscurrentState("customerPayment")
    //     updateIconSidebar(e)
    //   }
    // } : null,
    // roleName === "Customer" && customerPermission ? {
    //   id: "customerProfile",
    //   label: "Profile",
    //   icon: "ri ri-user-3-line",
    //   link: "/customer/profile",
    //   stateVariables: isCustomerProfile,
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsCustomerDashboard(!isCustomerProfile)
    //     setIscurrentState("customerPayment")
    //     updateIconSidebar(e)
    //   }
    // } : null,
    PartnerPermission && roleName !== "Customer"
      ? {
          id: "partner",
          label: "Partners",
          icon: " ri-group-line",
          link: "/#",
          stateVariables: isPartner,
          click: function (e) {
            e.preventDefault();
            setIsPartner(!isPartner);
            setIscurrentState("Partner");
            updateIconSidebar(e);
          },
          subItems: [
            PartnerPermission && PartnerPermission?.has("list")
              ? {
                  id: "partner",
                  label: "Partners",
                  link: "/partner-listing",
                  parentId: "partner",
                }
              : null,
            commissionPolicyPermission &&
            commissionPolicyPermission?.has("list")
              ? {
                  id: "settlement-policy",
                  label: "Settlement Policies",
                  link: "/policy",
                  parentId: "partner",
                }
              : null,
            PartnerPermission && PartnerPermission?.has("create")
              ? {
                  id: "create-partner",
                  label: "Add Partner",
                  link: "/create-partner",
                  parentId: "partner",
                }
              : null,
          ].filter(Boolean),
        }
      : null,
    customerPermission && roleName !== "Customer"
      ? {
          id: "customer",
          label: isEIPEnabled ? "Device" : "Customer",
          icon: "ri ri-user-3-line",
          link: "/#",
          stateVariables: isCustomer,
          click: function (e) {
            e.preventDefault();
            setIsCustomer(!isCustomer);
            setIscurrentState("Customer");
            updateIconSidebar(e);
          },
          subItems: [
            customerPermission && customerPermission?.has("list")
              ? {
                  id: "customer",
                  label: labelText,
                  link: "/customer",
                  parentId: "customer",
                }
              : null,
            customerPermission && customerPermission?.has("create")
              ? {
                  id: "create-customer",
                  label: isEIPEnabled ? "Add Device" : "Add Customer",
                  link: "/create-customer",
                  parentId: "customer",
                }
              : null,
            orderPermission
              ? {
                  id: "orders",
                  label: "Orders",
                  link: "/orders",
                  parentId: "customer",
                }
              : null,
            invoicePermission
              ? {
                  id: "invoices",
                  label: "Invoices",
                  link: "/invoices",
                  parentId: "customer",
                }
              : null,
            // taskPermission &&
            //   taskPermission?.has("list")
            //   ? {
            //     id: "tasks",
            //     label: "Activity Logs",
            //     link: "/tasks",
            //     parentId: "customer",
            //   }
            //   : null,
          ].filter(Boolean),
        }
      : null,
    (roleName === "systemUser" || roleName === "providerOperationUser") &&
    operatorPermission &&
    operatorPermission?.has("list")
      ? {
          id: "operator",
          label: "Operators",
          icon: " ri-group-line",
          link: "/operator-listing",
          stateVariables: isOperator,
          click: function (e) {
            e.preventDefault();
            setIsOperator(!isOperator);
            setIscurrentState("operator");
            updateIconSidebar(e);
          },
        }
      : null,
    // (roleName === "systemUser" || roleName === "providerOperationUser") && operatorPermission ? {
    //   id: "settings",
    //   label: "Settings",
    //   icon: "ri-settings-3-line",
    //   link: "/operator-listing",
    //   stateVariables: isSetting,
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsSetting(!isSetting)
    //     setIscurrentState("settings")
    //     updateIconSidebar(e)
    //   }
    // } : null,
    devicePermission && roleName !== "Customer"
      ? {
          id: "Device",
          label: "Device",
          icon: "ri-router-line",
          link: "/#",
          stateVariables: isDevice,
          click: function (e) {
            e.preventDefault();
            setIsDevice(!isDevice);
            setIscurrentState("Device");
            updateIconSidebar(e);
          },
          subItems: [
            devicePermission && devicePermission?.has("list")
              ? {
                  id: "customer",
                  label: "Devices",
                  link: "/devices",
                  parentId: "customer",
                }
              : null,
            devicePermission && devicePermission?.has("create")
              ? {
                  id: "customer",
                  label: "Add Device",
                  link: "/create-device",
                  parentId: "customer",
                }
              : null,
          ].filter(Boolean),
        }
      : null,

    stationPermission && roleName !== "Customer"
      ? {
          id: "station",
          label: "Station",
          icon: "bx bxs-ev-station",
          link: "/#",
          stateVariables: isStation,
          click: function (e) {
            e.preventDefault();
            setIsStation(!isStation);
            setIscurrentState("Station");
            updateIconSidebar(e);
          },
          subItems: [
            stationPermission && stationPermission?.has("list")
              ? {
                  id: "station",
                  label: "Stations",
                  link: "/station",
                  parentId: "station",
                }
              : null,
            stationPermission?.has("create")
              ? {
                  id: "station",
                  label: "Add Station",
                  link: "/create-station",
                  parentId: "station",
                }
              : null,
          ].filter(Boolean),
        }
      : null,
    reservationPermission && roleName !== "Customer"
      ? {
          id: "reservation",
          label: "Reservation",
          icon: "ri ri-reserved-line",
          link: "/#",
          stateVariables: isReservation,
          click: function (e) {
            e.preventDefault();
            setIsResevation(!isReservation);
            setIscurrentState("Reservation");
            updateIconSidebar(e);
          },
          subItems: [
            reservationPermission && reservationPermission?.has("list")
              ? {
                  id: "reservation",
                  label: "Reservations",
                  link: "/reservation",
                  parentId: "reservation",
                }
              : null,
            reservationPermission && reservationPermission?.has("create")
              ? {
                  id: "create reservation",
                  label: "Add Reservation",
                  link: "/create-reservation",
                  parentId: "createreservation",
                }
              : null,
          ].filter(Boolean),
        }
      : null,
    pricingPermission && roleName !== "Customer"
      ? {
          id: "pricing",
          label: isEIPEnabled ? "Plans" : "Pricing",
          icon: "las la-money-bill",
          link: "/#",
          stateVariables: isPricing,
          click: function (e) {
            e.preventDefault();
            setIsPricing(!isPricing);
            setIscurrentState("Pricing");
            updateIconSidebar(e);
          },
          subItems: [
            uomPermission && uomPermission?.has("list")
              ? {
                  id: "uom",
                  label: "UOM",
                  link: "/uom",
                  parentId: "pricing",
                }
              : null,
            attributePermission && attributePermission?.has("list")
              ? {
                  id: "attribute",
                  label: "Attributes",
                  link: "/attribute",
                  parentId: "pricing",
                }
              : null,
            resourcePermission && resourcePermission?.has("list")
              ? {
                  id: "resources",
                  label: "Resources",
                  link: "/resource",
                  parentId: "pricing",
                }
              : null,
            servicePermission && servicePermission?.has("list")
              ? {
                  id: "services",
                  label: "Services",
                  link: "/service",
                  parentId: "pricing",
                }
              : null,
            offerPermission && offerPermission?.has("list")
              ? {
                  id: "offer",
                  label: "Offers",
                  link: "/offer",
                  parentId: "pricing",
                }
              : null,
          ].filter(Boolean),
        }
      : null,
    chargingPermission && roleName !== "Customer" && !isEIPEnabled
      ? {
          id: "charging",
          label: "Charging",
          icon: "ri ri-wireless-charging-fill",
          link: "/#",
          stateVariables: isCharging,
          click: function (e) {
            e.preventDefault();
            setIsCharging(!isCharging);
            setIscurrentState("Charging");
            updateIconSidebar(e);
          },
          subItems: [
            peerconfigurationPermission &&
            peerconfigurationPermission?.has("list")
              ? {
                  id: "peerconfiguration",
                  label: "Peer Configuration",
                  link: "/peerconfiguration",
                  parentId: "charging",
                }
              : null,
            ratinggroupPermission && ratinggroupPermission?.has("list")
              ? {
                  id: "rating",
                  label: "Rating Group",
                  link: "/ratinggroup",
                  parentId: "charging",
                }
              : null,
            quotaPermission && quotaPermission?.has("list")
              ? {
                  id: "quota",
                  label: "Quota Configuration",
                  link: "/quotamanagement",
                  parentId: "charging",
                }
              : null,

            policyPermission &&
            policyPermission?.has("list") &&
            offerPermission &&
            offerPermission?.has("list")
              ? {
                  id: "Policy",
                  label: "Policy Specs",
                  link: "/policies",
                  parentId: "pricing",
                }
              : null,

            midsessionPermission && midsessionPermission?.has("list")
              ? {
                  id: "midSessionConfiguration",
                  label: "Mid Session Configuration",
                  link: "/midsession",
                  parentId: "charging",
                }
              : null,
          ].filter(Boolean),
        }
      : null,

    adminpartnerofferPermission && roleName !== "Customer"
      ? {
          id: "cms",
          label: "Offer",
          icon: "ri-router-line",
          link: "/#",
          stateVariables: isAdminPartnerOffer,
          click: function (e) {
            e.preventDefault();
            setIsAdminPartnerOffer(!isAdminPartnerOffer);
            setIscurrentState("Admin Partner Offer");
            updateIconSidebar(e);
          },
          subItems: [
            adminpartnerofferPermission?.has("list")
              ? {
                  id: "cms-offers-list",
                  label: "Offers List",
                  link: "/offers",
                  parentId: "cms",
                }
              : null,

            adminpartnerofferPermission?.has("create")
              ? {
                  id: "cms-add-offer",
                  label: "Add Offers",
                  link: "/offer-create",
                  parentId: "cms",
                }
              : null,
          ].filter(Boolean),
        }
      : null,

    isMLAnalyticsEnabled && roleName !== "systemUser"
      ? {
          id: "analytics",
          label: "Analytics",
          icon: "ri ri-bar-chart-fill",
          // link: "/#",
          stateVariables: isAnalytics,
          click: function (e) {
            e.preventDefault();
            setIsAnalytics(!isAnalytics);
            setIscurrentState("Analytics");
            // updateIconSidebar(e);
            redirectToMLDashboard();
          },
        }
      : null,

    // (reportPermission)
    // ? {
    //   id: "report",
    //   label: "Reports",
    //   icon: "ri ri-line-chart-fill",
    //   link: "/report",
    //   stateVariables: isReport,
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsReport(!isReport);
    //     setIscurrentState("Report");
    //     updateIconSidebar(e);
    //   },
    // }
    // : null,

  reportPermission
    ? {
        id: "reports",
        label: "Reports",
        icon: "ri ri-line-chart-fill",
        link: "/charging-session-report",
        stateVariables: isReport,
        click: function (e) {
          e.preventDefault();
          setIsReport(true);
          setIscurrentState("Report");
          updateIconSidebar(e);
          history("/charging-session-report");
        },
        subItems: [
          {
            id: "charging-session-report",
            label: "Charging Session Report",
            link: "/charging-session-report",
            parentId: "reports",
          },
          {
            id: "business-performance-report",
            label: "Business Performance Report",
            link: "/business-performance-report",
            parentId: "reports",
          },
        ],
      }
    : null,

    emsReportPermission && isEIPEnabled
      ? {
          id: "emsreport",
          label: "Reports",
          icon: "ri ri-line-chart-fill",
          link: "/reports",
          stateVariables: isEMSReport,
          click: function (e) {
            e.preventDefault();
            setIsEMSReport(!isEMSReport);
            setIscurrentState("EMS Report");
            updateIconSidebar(e);
          },
        }
      : null,

    transactionPermission && roleName !== "Customer"
      ? {
          id: "transactions",
          label: "Inventory Transactions",
          icon: " ri-list-check-2",
          link: "/#",
          stateVariables: isTransactions,
          click: function (e) {
            e.preventDefault();
            setIsTransactions(!isTransactions);
            setIscurrentState("Transactions");
            updateIconSidebar(e);
          },
          subItems: [
            inventoryPermission && inventoryPermission?.has("list")
              ? {
                  id: "inventory",
                  label: "Inventory List",
                  link: "/inventory",
                  parentId: "transactions",
                }
              : null,
            purchaseorderPermission && purchaseorderPermission?.has("list")
              ? {
                  id: "purchaseorder",
                  label: "Purchase Orders",
                  link: "/purchaseorder",
                  parentId: "transactions",
                }
              : null,
            salesorderPermission && salesorderPermission?.has("list")
              ? {
                  id: "salesorder",
                  label: "Sales Orders",
                  link: "/salesorder",
                  parentId: "transactions",
                }
              : null,
            stocktranferPermission && stocktranferPermission?.has("list")
              ? {
                  id: "transfer",
                  label: "Stock Transfer",
                  link: "/stocktransfer",
                  parentId: "transactions",
                }
              : null,
            adjustmentsPermission && adjustmentsPermission?.has("list")
              ? {
                  id: "adjustment",
                  label: "Stock Adjustments",
                  link: "/adjustment",
                  parentId: "transactions",
                }
              : null,
          ].filter(Boolean),
        }
      : null,

    monitoringAndControlPermission && roleName !== "Customer"
      ? {
          id: "monitoringAndControl",
          label: "Monitoring and Control",
          icon: "ri-menu-2-line",
          link: "/#",
          stateVariables: isMonitoringAndControl,
          click: function (e) {
            e.preventDefault();
            setIsMonitoringAndControl(!isMonitoringAndControl);
            setIscurrentState("Monitoring and Control");
            updateIconSidebar(e);
          },
          subItems: [
            notificationsPermission && notificationsPermission?.has("list")
              ? {
                  id: "notifications",
                  label: "Approval Notifications",
                  link: "/notifications",
                  parentId: "monitoringAndControl",
                }
              : null,
          ].filter(Boolean),
        }
      : null,

    configurationsPermission && roleName !== "Customer"
      ? {
          id: "configuration",
          label: "Configuration",
          icon: "ri-settings-2-line",
          link: "/#",
          stateVariables: isConfigurations,
          click: function (e) {
            e.preventDefault();
            setIsConfigurations(!isConfigurations);
            setIscurrentState("Configuration");
            updateIconSidebar(e);
          },
          subItems: [
            locationPermission && locationPermission?.has("list")
              ? {
                  id: "locations",
                  label: "Locations",
                  link: "/locations",
                  parentId: "configuration",
                }
              : null,
            uomInventoryPermission && uomInventoryPermission?.has("list")
              ? {
                  id: "uom",
                  label: "Unit",
                  link: "/uom",
                  parentId: "configuration",
                }
              : null,
            categoryPermission && categoryPermission?.has("list")
              ? {
                  id: "category",
                  label: "Category",
                  link: "/category",
                  parentId: "configuration",
                }
              : null,
            attributeInventoryPermission &&
            attributeInventoryPermission?.has("list")
              ? {
                  id: "attribute",
                  label: "Attribute",
                  link: "/attribute",
                  parentId: "configuration",
                }
              : null,
            itemPermission && itemPermission?.has("list")
              ? {
                  id: "items",
                  label: "Products",
                  link: "/items",
                  parentId: "configuration",
                }
              : null,
            pricebookPermission && pricebookPermission?.has("list")
              ? {
                  id: "pricebook",
                  label: "Price Book",
                  link: "/pricebook",
                  parentId: "configuration",
                }
              : null,
          ].filter(Boolean),
        }
      : null,

    //  (roleName === "evAdmin")
    // ? {
    //   id: "step-tracking",
    //   label: "Step Tracker",
    //   icon: "ri ri-footprint-fill",
    //   link: "/step-tracking",
    //   stateVariables: isStepTracking,
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsStepTracking(!isStepTracking);
    //     setIscurrentState("Step Tracker");
    //     updateIconSidebar(e);
    //   },
    // }
    // : null,

    roleName !== "Customer" &&
    ((userPermission && userPermission?.has("list")) ||
      (profilePermission && profilePermission?.has("view")))
      ? {
          id: "user",
          label: "Administration",
          icon: "ri ri-admin-line",
          link: "/#",
          stateVariables: isUser,
          click: function (e) {
            e.preventDefault();
            setIsUser(!isUser);
            setIscurrentState("User");
            updateIconSidebar(e);
          },
          subItems: [
            userPermission && userPermission?.has("list")
              ? {
                  id: "user",
                  label: "Users ",
                  link: "/user",
                  parentId: "user",
                }
              : null,
            rolesPermission && rolesPermission?.has("list")
              ? {
                  id: "userroles",
                  label: "User Roles ",
                  link: "/userroles",
                  parentId: "userroles",
                }
              : null,
            profilePermission && profilePermission?.has("view")
              ? {
                  id: "operator",
                  label: "Business Profile",
                  link: "/business-profile",
                  parentId: "operator",
                }
              : null,
            configurationPermission && configurationPermission?.has("create")
              ? {
                  id: "configuration",
                  label: "Configurations",
                  link: "/create-configurations",
                  parentId: "operator",
                }
              : null,
          ].filter(Boolean),
        }
      : null,

    //////New///////
    // dashboardPermission && roleName !== "Customer"
    //   ? {
    //     id: "dashboard",
    //     label: "Transactions",
    //     icon: "ri-dashboard-line",
    //     link: "/transactions",
    //     stateVariables: isDashboard,
    //     click: function (e) {
    //       e.preventDefault();
    //       setIsDashboard(!isDashboard);
    //       setIscurrentState("Dashboard");
    //       updateIconSidebar(e);
    //     },
    //   }
    //   : null,
  ].filter(Boolean);
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
